import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ParasOrganicsHome from "../ParasOrganics_Homepage";
import ApplicationPage from "../pages/ApplicationPage";
import BlogDetailPage from "../pages/BlogDetailPage";
import BlogListingPage from "../pages/BlogListingPage";
import ContactPage from "../pages/ContactPage";
import ContactThankYouPage from "../pages/ContactThankYouPage";
import PlaceholderPage from "../pages/PlaceholderPage";
import ProductDetailPage from "../pages/ProductDetailPage";
import { futureRoutes } from "./routeConfig";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ParasOrganicsHome />} />
        <Route path="/vermicompost" element={<ProductDetailPage productKey="vermicompost" />} />
        <Route path="/vermiwash" element={<ProductDetailPage productKey="vermiwash" />} />
        <Route path="/applications/home-garden" element={<ApplicationPage pageKey="home-garden" />} />
        <Route path="/applications/agriculture" element={<ApplicationPage pageKey="agriculture" />} />
        <Route path="/applications/nursery-landscaping" element={<ApplicationPage pageKey="nursery-landscaping" />} />
        <Route path="/blog" element={<BlogListingPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/contact/thank-you" element={<ContactThankYouPage />} />
        {futureRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={<PlaceholderPage title={route.title} />} />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
